import { getChannelList, categoryList, getFullchannels } from "../Api";
import { LOCALE_CHANELS_IDS } from "../constants/chanels.js";
import { matchSearchQuery } from "../matchSearchQuery.js";
export default {
    state: {
        categoryList: [],
        chanelsListFull: [],
        chanelsList: [],
        chanelsListDublicate: [],
        chanelsFavourites: null,
        loading: true,
        isChanelSerached: false,
        isLoggined: false,
        activecategory: null,
        isLoadingCategories: true,
        isLoadingEpg: true,
    },
    actions: {
        async fetchCategories({ commit }, payload) {
            const { lang } = payload;
            try {
                const respons = await categoryList(lang);
                commit("SET_CATEGORIES", respons);
                commit("SET_LOADING_CATEGORIES", false);
            } catch (error) {
                console.error(error);
                commit("SET_LOADING_CATEGORIES", false);
            }
        },
        async fetchChanels({ commit, state }, payload) {
            const { loggined, isWorld } = payload;
            try {
                const respons = loggined
                    ? await getChannelList()
                    : await getFullchannels();

                commit("SET_CHANELS", {
                    respons: respons,
                    isWorld: isWorld,
                    isLoggined: loggined,
                });
                commit("SET_LOADING", false);
            } catch (error) {
                const respons = await getFullchannels();
                commit("SET_CHANELS", {
                    respons: respons,
                    isWorld: isWorld,
                    isLoggined: false,
                });
                commit("SET_LOADING", false);
            }
        },
    },
    mutations: {
        SET_CATEGORIES(state, content) {
            const categories = content.categories.item
                ? content.categories.item
                : content.categories;
            const filteredCategories = categories.filter(
                (i) => i.id !== 10 && i.id !== 9
            );
            const index = filteredCategories.findIndex((item) => item.id === 7);
            if (index !== -1) {
                const [item] = filteredCategories.splice(index, 1);
                filteredCategories.unshift(item);
            }
            state.categoryList = filteredCategories;
        },
        SET_CHANELS(state, content) {
            const { respons, isWorld, isLoggined } = content;
            state.isLoggined = isLoggined;
            let channels;
            if (isLoggined) {
                try {
                    channels = respons.channels.item
                        ? respons.channels.item
                        : respons.channels;
                } catch (error) {
                    console.log(error);
                }
            } else {
                channels = respons;
            }
            // const filteredChanels = [];
            // const localChannels = LOCALE_CHANELS_IDS;
            // if (isWorld) {
            //     for (let i = 0; i < localChannels.length; i++) {
            //         let item = channels.filter(
            //             (items) => items.id == localChannels[i]
            //         )[0];
            //         if (item) {
            //             filteredChanels.push(item);
            //         }
            //     }
            //     state.chanelsList.length = 0;
            // } else {
            //     filteredChanels.push(...channels);
            // }
            state.chanelsListFull = channels;
            if (state.chanelsList.length === 0) {
                state.chanelsList = channels;
            }
            // state.chanelsListDublicate = filteredChanels;
            state.chanelsFavourites = state.chanelsListFull
                .filter((channel) => channel.is_favorited === 1)
                .map((channel) => channel.id);
        },
        SET_FAVORITED_CHANELS(state, content) {
            const channels = state.chanelsListFull.reduce((acc, channel) => {
                if (channel.is_favorited) acc.push(channel);
                return acc;
            }, []);
            const favoriteChannels = state.chanelsListFull?.filter((channel) =>
                state.chanelsFavourites.includes(channel.id)
            );
            if (state.activecategory === "favoritesInner") {
                state.chanelsList = favoriteChannels;
            } else if (state.activecategory === "favorites") {
                state.chanelsList = channels;
            }
            state.chanelsListDublicate = channels;
        },
        SET_LOADING(state, content) {
            state.loading = content;
        },
        SET_LOADING_CATEGORIES(state, content) {
            state.isLoadingCategories = content;
        },
        SET_LOADING_EPG(state, content) {
            state.isLoadingEpg = content;
        },
        SET_FILTERED_CHANELS(state, id) {
            let channels;
            if (id && id !== "all") {
                const filterCondition = state.isLoggined
                    ? "category_id"
                    : "category";
                if (id === 7) {
                    channels = state.chanelsListFull?.filter(
                        (channel) =>
                            Array.isArray(channel.additional_categories) &&
                            channel.additional_categories.length > 0
                    );
                } else {
                    channels = state.chanelsListFull?.filter(
                        (channel) => channel[filterCondition] == id
                    );
                }
            } else {
                channels = state.chanelsListFull;
            }
            state.chanelsList = channels;
            state.chanelsListDublicate = channels;
        },
        SET_SEARCHED_CHANELS(state, content) {
            const { to } = content;

            let channels;
            if (to) {
                channels = state.chanelsListFull?.filter((i) =>
                    matchSearchQuery(to, i.name)
                );
            } else {
                channels = state.chanelsListFull;
            }

            state.chanelsList = channels;
            state.isChanelSerached = !channels?.length;
        },

        SET_ACTIVE_CATEGORY(state, content) {
            state.activecategory = content;
        },
        CLEAR_CHANELS(state) {
            state.chanelsListFull = "";
            state.chanelsList = "";
            state.chanelsListDublicate = "";
            state.activecategory = null;
            state.loading = true;
        },
        CLEAR_CHANELSLIST(state) {
            state.chanelsList = state.chanelsListFull;
            state.chanelsListDublicate = state.chanelsListFull;
            state.activecategory = null;
            // state.loading = true;
        },
        SET_STATIC_FAVOURITE(state, content) {
            const channelId = +content;
            state.chanelsFavourites.push(channelId);

            const currentFull = state?.chanelsListFull?.find(
                (item) => item.id === channelId
            );
            const currentList = state?.chanelsList?.find(
                (item) => item.id === channelId
            );
            const currentDubl = state.chanelsListDublicate
                ? state.chanelsListDublicate.find(
                      (item) => item.id === channelId
                  )
                : null;

            if (currentFull) currentFull.is_favorited = 1;
            if (currentList) currentList.is_favorited = 1;
            if (currentDubl) currentDubl.is_favorited = 1;
        },

        REMOVE_STATIC_FAVOURITE(state, content) {
            const channelId = +content;
            const index = state.chanelsFavourites.findIndex(
                (i) => i === channelId
            );

            if (index !== -1) {
                state.chanelsFavourites.splice(index, 1);

                const currentFull = state?.chanelsListFull?.find(
                    (item) => item.id === channelId
                );
                const currentList = state?.chanelsList?.find(
                    (item) => item.id === channelId
                );
                const currentDubl = state.chanelsListDublicate
                    ? state.chanelsListDublicate.find(
                          (item) => item.id === channelId
                      )
                    : null;

                if (currentFull) currentFull.is_favorited = 0;
                if (currentList) currentList.is_favorited = 0;
                if (currentDubl) currentDubl.is_favorited = 0;
            }
        },
        SET_FULL_LIST(state) {
            state.chanelsList = state.chanelsListFull;
        },
        SET_CLEAR_CHANELS(state) {
            state.chanelsListFull = [];
            state.chanelsList = [];
            state.chanelsListDublicate = [];
            state.loading = true;
        },
    },
    getters: {
        getCategoryList(state) {
            return state.categoryList;
        },
        getCurrentChanel: (state) => (id) => {
            if (!state.chanelsListFull) return;
            return state.chanelsListFull?.filter((item) => item.id == id)[0];
        },
        getChanelsList(state) {
            return state.chanelsList;
        },
        getChanelsListFull(state) {
            return state.chanelsListFull;
        },
        getLoading(state) {
            return state.loading;
        },
        getIsChanelSerached(state) {
            return state.isChanelSerached;
        },
        getSelectedCategory(state) {
            return state.activecategory;
        },
        getStaticFavs(state) {
            return state.chanelsFavourites;
        },
        getIsLoadingCategories(state) {
            return state.isLoadingCategories;
        },
        getIsLoadingEpg(state) {
            return state.isLoadingEpg;
        },
    },
};
